// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.resellerordermodify', {
        url: '/modify/{orderId:int}',
        templateUrl: 'main/resellerorder/resellerordermodify/resellerordermodify.tpl.html',
        controller: 'ResellerOrderModifyController as vm',
        resolve: {
            resellerOrder: resellerOrderResolver
        },
        params: {
        }
    });
}

// @ngInject
function resellerOrderResolver($stateParams, ResellerOrdersApiService) {
    return ResellerOrdersApiService.getOrderById($stateParams.orderId);
}

// @ngInject
function ResellerOrderModifyController($window, $rootScope, $state, $translate, resellerOrder,
    ResellerOrdersApiService, confirmationDialogService, setFieldConfirmationDialogService,
    loadSpinnerService, ToasterService, printLanguageConfirmationDialogService) {
    var vm = this;

    //Properties
    vm.resellerOrder = resellerOrder.order;
    vm.resellerOrder.links = resellerOrder.links;
    vm.links = resellerOrder.links;
    vm.canAccess = $rootScope.canAccess;
    vm.showSearchFields = false;
    vm.synchronizationStatus = '';
    vm.isSaving = false;
    vm.isEditingOrderNumber = false;
    vm.editedOrderNumber = '';

    //Public methods
    vm.canCancelOrder = canCancelOrder;
    vm.cancelOrder = cancelOrder;
    vm.canConfirmOrder = canConfirmOrder;
    vm.confirmOrder = confirmOrder;
    vm.canPrintOrder = canPrintOrder;
    vm.printOrder = printOrder;
    vm.saveLineItem = saveLineItem;
    vm.saveVariant = saveVariant;
    vm.createNewOrder = createNewOrder;
    vm.createNewReturnOrder = createNewReturnOrder;
    vm.getResellerOrderCsv = getResellerOrderCsv;
    vm.toggleSearchFields = toggleSearchFields;
    vm.canSetWholeOrderDeliveryDate = canSetWholeOrderDeliveryDate;
    vm.canSetWholeOrderDiscountPercent = canSetWholeOrderDiscountPercent;
    vm.setWholeOrderDeliveryDate = setWholeOrderDeliveryDate;
    vm.setWholeOrderDiscountPercent = setWholeOrderDiscountPercent;
    vm.editOrderNumber = editOrderNumber;
    vm.tryToSaveNewOrderNumber = tryToSaveNewOrderNumber;

    activate();

    function activate() {
        if (vm.resellerOrder.id !== 0) {
            //get product variants
            var lineItemsGroupedByArticle = _.chain(vm.resellerOrder.lineItems)
                // Group the elements of Array based on `color` property
                .groupBy('articleId')
                // `key` is group's name (color), `value` is the array of objects
                .map((value, key) => ({ article: { id: parseInt(key), showRows: false }, lineItems: value }))
                .value();

            loadSpinnerService.start('mainSpinner');
            _.forEach(lineItemsGroupedByArticle, function(li) {
                ResellerOrdersApiService.getVariantsForProduct(li.article.id).then(function (response) {
                    fillOutArticle(response.data.variants);
                });
            });
            loadSpinnerService.stop('mainSpinner');
        }

        vm.synchronizationStatus = $translate.instant("common.allChangesSaved");
        $rootScope.$on('ResellerOrder.savingChanges', function() {
            vm.synchronizationStatus = $translate.instant("common.savingChanges");
            vm.isSaving = true;
        });
        $rootScope.$on('ResellerOrder.allChangesSaved', function() {
            vm.synchronizationStatus = $translate.instant("common.allChangesSaved");
            vm.isSaving = false;
        });
    }

    
    function editOrderNumber() {
        vm.isEditingOrderNumber = true;
        vm.editedOrderNumber = vm.resellerOrder.orderNumber;
    }

    function tryToSaveNewOrderNumber() {
        vm.isEditingOrderNumber = false;
        if(vm.editedOrderNumber === vm.resellerOrder.orderNumber){
            ToasterService.showError($translate.instant('productimport.noChangesToSave') + ' ' + angular.lowercase($translate.instant('common.in') + ' ' + $translate.instant('resellerorder.orderNumber') + '!'));
            return;
        }
        
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.changeOrderNumber(vm.editedOrderNumber, vm.resellerOrder.id).then(function () {
            vm.resellerOrder.orderNumber = vm.editedOrderNumber;
            ToasterService.showSuccess($translate.instant('common.new') + ' ' + angular.lowercase($translate.instant('resellerorder.orderNumber')) + ': "' + vm.editedOrderNumber + '" ' + angular.lowercase($translate.instant('common.wasSaved') + '!'));
        }, function (error){
            vm.isEditingOrderNumber = true;
            ToasterService.showError(error.message);
        }).finally(function(){
            loadSpinnerService.stop('mainSpinner');
        });
    }
    
    function createNewOrder() {
        $state.go('resellerorder.resellerordercreate');
    }

    function createNewReturnOrder() {
        $state.go('resellerorder.resellerreturnordercreate');
    }

    function getResellerOrderCsv() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getResellerOrderCsv(vm.resellerOrder.id, result.locale).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }
    function canPrintOrder() {
        var hasLineItems = vm.resellerOrder.lineItems && vm.resellerOrder.lineItems.length > 0;

        return hasLineItems;
    }
    function printOrder() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + ' PDF?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getResellerOrderPdf(vm.resellerOrder.id, result.locale).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function canSetWholeOrderDeliveryDate() {
        var hasLineItems = vm.resellerOrder.lineItems && vm.resellerOrder.lineItems.length > 0;
        var hasLink = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'updateDeliveryDate'; }) !== undefined;

        return hasLineItems && hasLink;
    }
    function canSetWholeOrderDiscountPercent() {
        var hasLineItems = vm.resellerOrder.lineItems && vm.resellerOrder.lineItems.length > 0;
        var hasLink = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'updateDiscountPercent'; }) !== undefined;

        return hasLineItems && hasLink;
    }

    function setWholeOrderDeliveryDate() {
        setFieldConfirmationDialogService.showDialog($translate.instant('resellerorder.confirmationSetWholeOrderDeliveryDate'), '', 'date', null, null).then(function (result) {
            if (result.isCompleted === true) {
                loadSpinnerService.start("mainSpinner");
                var request = {
                    orderId: vm.resellerOrder.id,
                    deliveryDateUtc: result.dateValue
                };
                ResellerOrdersApiService.setWholeOrderDeliverDate(request).then(function(response) {
                    //reload page
                    $window.location.reload();
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, error.message);
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function setWholeOrderDiscountPercent() {
        setFieldConfirmationDialogService.showDialog($translate.instant('resellerorder.confirmSetWholeOrderDiscountPercent'), '', 'number', 0, 100).then(function (result) {
            if (result.isCompleted === true) {
                loadSpinnerService.start("mainSpinner");
                var request = {
                    orderId: vm.resellerOrder.id,
                    discountPercent: result.numberValue / 100
                };
                ResellerOrdersApiService.setWholeOrderDiscountPercent(request).then(function(response) {
                    _.forEach(vm.resellerOrder.lineItems, function(lineItem){
                        if(lineItem.quantity > 0){
                            lineItem.discountPercent = result.numberValue / 100;
                            lineItem.discountDisplayPercent = lineItem.quantity + '%';
                        }
                    });
                    //reload page
                    $window.location.reload();
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, error.message);
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }


    function toggleSearchFields() {
        vm.showSearchFields = !vm.showSearchFields;
    }

    function fillOutArticle(variants) {
        _.forEach(variants, function(v) {
            var existingLineItem = _.find(vm.resellerOrder.lineItems, function(li) { return li.articleVariantId === v.id; });
            if (existingLineItem === undefined) {
                var newLineItem = {
                    amount: 0,
                    articleId: v.articleId,
                    articleName: v.articleName,
                    articleVariantId: v.id,
                    fulfilledQuantity: 0,
                    id: 0,
                    links: [{ rel: 'modify' }],
                    orderId: vm.resellerOrder.id,
                    quantity: 0,
                    status: 'open',
                    variantDetail1Name: v.variantDetail1Name,
                    variantDetail2Name: v.variantDetail2Name,
                    variantDetail2SortOrder: v.variantDetail2SortOrder,
                    vatAmount: 0,
                    vatRate: 0
                };
                vm.resellerOrder.lineItems.push(newLineItem);
            }
        });
    }

    function saveLineItem(lineItem) {
        var request = {
            orderId: lineItem.orderId,
            lineItems: [{
                articleVariantId: lineItem.articleVariantId,
                discountPercent: lineItem.discountPercent,
                plannedDeliveryDateUtc: lineItem.plannedDeliveryDateUtc,
                price: lineItem.amount,
                quantity: lineItem.quantity
            }]
        };

        $rootScope.$emit('ResellerOrder.savingChanges', '');
        ResellerOrdersApiService.upsertLineItems(request).then(function (response) {
            vm.resellerOrder.links = response.data.links;
            $rootScope.$emit('ResellerOrder.allChangesSaved', '');
        }, function (error) {
            console.log(error);
        }).then(function () {
        });
    }

    function saveVariant(variant) {
        var request = {
            orderId: variant.lineItems[0].orderId,
            lineItems: []
        };
        _.forEach(variant.lineItems, function(lineItem) {
            request.lineItems.push({
                articleVariantId: lineItem.articleVariantId,
                discountPercent: lineItem.discountPercent,
                plannedDeliveryDateUtc: lineItem.plannedDeliveryDateUtc,
                price: lineItem.amount,
                quantity: lineItem.quantity
            });
        });

        $rootScope.$emit('ResellerOrder.savingChanges', '');
        ResellerOrdersApiService.upsertLineItems(request).then(function (response) {
            vm.resellerOrder.links = response.data.links;
            $rootScope.$emit('ResellerOrder.allChangesSaved', '');
        }, function (error) {
            console.log(error);
        }).finally(function () {
        });
    }

    function canConfirmOrder() {
        var hasLineItems = vm.resellerOrder.lineItems && vm.resellerOrder.lineItems.length > 0;
        var hasLink = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'confirm'; }) !== undefined;

        return hasLineItems && hasLink;
    }

    function canCancelOrder() {
        var hasDeleteLink = _.find(vm.links, function(o) { return o.rel === 'delete'; }) !== undefined;

        return hasDeleteLink;
    }

    function cancelOrder() {
        //confirm scrap order
        confirmationDialogService.showDialog($translate.instant('resellerorder.confirmCancelOrder'), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                //clear line items and order head
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.deleteOrder(vm.resellerOrder.id).then(function () {
                    ToasterService.showInfo($translate.instant('resellerorder.orderDeleted'), $translate.instant('common.information'));
                    $state.go('resellerorder.resellerordersearch');
                }, function (error) {
                    console.log(error);
                    ToasterService.showError(error.error, $translate.instant('common.error'));
                }).then(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function confirmOrder() {
        confirmationDialogService.showDialog($translate.instant("resellerorder.confirmConfirmOrder"), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                //call backend, confirm order
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.confirm(vm.resellerOrder.id).then(function () {
                    ToasterService.showInfo($translate.instant('resellerorder.orderConfirmed'), $translate.instant('common.information'));

                    $state.go('resellerorder.resellerorderview', { orderId: vm.resellerOrder.id });
                }, function (error) {
                    console.log(error);
                    ToasterService.showError(error.error, $translate.instant('common.error'));
                }).then(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }
}

angular
    .module('resellerorder.resellerordermodify', [])
    .config(stateConfig)
    .controller('ResellerOrderModifyController', ResellerOrderModifyController);
